import { render, staticRenderFns } from "./website-course.vue?vue&type=template&id=3a9bbfc8&scoped=true"
import script from "./website-course.vue?vue&type=script&lang=js"
export * from "./website-course.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9bbfc8",
  null
  
)

export default component.exports